<script setup lang="ts">

// import SelectInput from "@/modules/form/components/SelectInput.vue";
import { Field } from "@/modules/form/lib/field";
import { Model } from "@/modules/form/lib/model";
// import { RequiredRule } from "@/modules/form/rules/required";
// import { StringRule } from "@/modules/form/rules/string";
// import { mdiAccount, mdiFormTextboxPassword, mdiSend } from "@mdi/js";
// import { metadata } from "@/lib/metadata";
// import { isDark } from "@/modules/theme";
// import Icon from "@/components/Icon.vue";
import { translate } from "@/lib/metadata";
import Button from "@/modules/bootstrap/components/Button.vue";
import StringInput from "@/modules/form/components/StringInput.vue";
import RecaptchaInput from '@/modules/form/components/RecaptchaInput.vue';
import TextInput from "@/modules/form/components/TextInput.vue";
import { createModel } from "@/modules/form/hooks/model";
import { onMounted, onUnmounted, ref } from "vue";
import { api } from "@/lib/api";
import { Contact } from "@/forms/contact";
import { successToast } from '../modules/bootstrap/lib/toast';


const button = ref<any>(null);

const [model, newModel, destroyModel] = createModel(Contact);

const send = () => {
    model.value?.validate()?.then((valid: boolean) => {
        if (valid) {
            button.value?.start?.();

            const data = { ...model.value?.data };

            api().post('/Contact', { 'data': data }).then((res) => {
                newModel();
                successToast("Success", "Email Sent Successfully")
            })
                .catch((err) => {
                    model.value?.addRemoteErrors?.(err);
                })
                .finally(() => {
                    button.value?.stop?.();
                });
        }
    });
};

onMounted(() => {
    newModel();
});

onUnmounted(() => {
    destroyModel();
});
</script>
<template>
    <form
        v-if="model"
        @submit.prevent="send"
        class="contact-form"
    >
        <div class="inputs-holder">

            <div class="form-row">
                <div class="col-input">
                    <StringInput
                        :field="model.fullname"
                        class="form-control"
                        :placeholder='translate("Name")'
                    >

                    </StringInput>
                </div>
                <div class="col-input">
                    <StringInput
                        :field="model.email"
                        class="form-control"
                        :placeholder='translate("Email")'
                    >

                    </StringInput>
                </div>
            </div>


            <div class="form-row">
                <div class="col-input">
                    <StringInput
                        :field="model.phone_number"
                        class="form-control"
                        :placeholder='translate("Phone")'
                    >

                    </StringInput>
                </div>
                <div class="col-input">
                    <StringInput
                        :field="model.location"
                        class="form-control"
                        :placeholder='translate("Address")'
                    >

                    </StringInput>
                </div>
            </div>
            <div class="form-group">
                <TextInput
                    :field="model.message"
                    class="form-control"
                    :placeholder='translate("Message")'
                >

                </TextInput>
            </div>
            <div class="my-3">
                <RecaptchaInput :field="model.recap">
                </RecaptchaInput>
            </div>
        </div>

        <div class="send-btn">
            <Button
                type="submit"
                class="site-button"
                spinner-color="light"
                ref="button"
            >
                {{ translate("Send Message") }}

            </Button>
        </div>
    </form>
</template>
